import { i18n } from 'shared/i18n'

// window.Materialize is set by materialize-css, which each app loads from its
// own entry: admin-web's index.js, legacy client-web's pages/_app.js.
export class ToastNotification {
    static notificationWithoutTranslation(text) {
        window.Materialize.toast(text, 10 * 1000, 'blue-grey lighten-4 z-depth-5 grey-text text-darken-4')
    }
    static success(text) {
        window.Materialize.toast(i18n().t(text), 3000, 'teal accent-4')
    }
    static warning(text) {
        window.Materialize.toast(i18n().t(text), 3000, 'orange darken-2')
    }
    static error(text = "Operation has failed, try again later") {
        window.Materialize.toast(i18n().t(text), 6000, 'red darken-1')
    }
}
